document.addEventListener("DOMContentLoaded", function () {
  
  document.querySelectorAll(".dropdown_button").forEach((btn) => {
    btn.addEventListener("click", function (e) {
      e.preventDefault();
      document.querySelectorAll(".open-dropdown").forEach(dropdown=>{
        dropdown.classList.remove('open-dropdown');
      })
      if (
        document
          .querySelector(`#${this.dataset.id}`)
          .classList.contains("open-dropdown")
      ) {
        document
          .querySelector(`#${this.dataset.id}`)
          .classList.remove("open-dropdown");
      } else {
        document
          .querySelector(`#${this.dataset.id}`)
          .classList.add("open-dropdown");
      }
    });
  });

  document.querySelectorAll(".opt-label").forEach((btn) => {
    btn.addEventListener("click", function (e) {
      e.preventDefault();
      this.closest("fieldset")
        .querySelectorAll("label.checked")
        .forEach((label) => {
          label.classList.remove("checked");
        });
      this.classList.add("checked");
      let value = this.dataset.swatch;
      
      
      this.closest(".dropdown_list").querySelector(
        "button span:not(.selected-color)"
      ).innerText = value;
      this.closest(".dropdown_list")
        .querySelector("button span.selected-color")
        .setAttribute("data-swatch", value);
      let variantValue = this.closest('.dropdown_list').querySelector('[name=variant-data]').value;
      variantValue = JSON.parse(variantValue);
      let variant_input = this.closest('.courses').querySelector('[name=shade-variant]');
      variantValue.forEach(variant=>{
        let title = variant.title.toLowerCase()
        if(title == value){
         
          variant_input.value = variant.id;
          variant_input.dataset.bundleComponentPrice = variant.price;
        }
      })
     
    });
  });
});